import React, { useMemo } from 'react';
import '../../../../css/_analytics_viz.css';

function cellClass(value) {
  if (value == null || Number.isNaN(value)) return 'similarity-cell';
  const v = Number(value);
  if (v >= 0.6) return 'similarity-cell similarity-cell-strong';
  if (v >= 0.4) return 'similarity-cell similarity-cell-medium';
  if (v > 0) return 'similarity-cell similarity-cell-soft';
  return 'similarity-cell';
}

function cellText(value) {
  return value == null ? '' : Number(value).toFixed(2);
}

/**
 * N×N similarity matrix. Rows are `{ identifier, similar_to, similarity }`
 * pairs (from the `similarities` node); the matrix is filled symmetrically
 * and missing pairs render as 0.
 */
export default function MatrixViz({ rows }) {
  const { labels, matrix } = useMemo(() => {
    const ids = [];
    for (const row of rows || []) {
      for (const key of ['identifier', 'similar_to']) {
        const value = row[key];
        if (value != null && !ids.includes(value)) ids.push(value);
      }
    }
    const size = ids.length;
    const cells = ids.map(() => ids.map(() => null));
    ids.forEach((id, i) => {
      cells[i][i] = 1;
    });
    for (const row of rows || []) {
      const a = ids.indexOf(row.identifier);
      const b = ids.indexOf(row.similar_to);
      if (a === -1 || b === -1) continue;
      const value = Number(row.similarity);
      if (Number.isFinite(value)) {
        cells[a][b] = value;
        cells[b][a] = Math.max(cells[b][a] ?? 0, value);
      }
    }
    return { labels: ids, matrix: cells };
  }, [rows]);

  if (labels.length === 0) {
    return (
      <div className="analysis-empty">
        <span className="material-symbols-rounded analysis-empty-icon">merge</span>
        <span>No similarity pairs found.</span>
      </div>
    );
  }

  return (
    <div className="similarity-matrix">
      <table>
        <thead>
          <tr>
            <th />
            {labels.map((id) => (
              <th key={`h-${id}`}>{id}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {labels.map((rowId, i) => (
            <tr key={`r-${rowId}`}>
              <th>{rowId}</th>
              {labels.map((colId, j) => {
                const value = matrix[i][j];
                return (
                  <td key={`c-${rowId}-${colId}`} className={cellClass(value)}>
                    {cellText(value)}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
